import { render, staticRenderFns } from "./lib-switcher.vue?vue&type=template&id=6384a9c5&scoped=true"
import script from "./lib-switcher.vue?vue&type=script&lang=js"
export * from "./lib-switcher.vue?vue&type=script&lang=js"
import style0 from "./lib-switcher.vue?vue&type=style&index=0&id=6384a9c5&prod&lang=css"
import style1 from "./lib-switcher.vue?vue&type=style&index=1&id=6384a9c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6384a9c5",
  null
  
)

export default component.exports